import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "./Modal";

type ConfirmModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  message: React.ReactNode;
  confirmLabel?: string;
};

export default function ConfirmModal({
  open,
  onOpenChange,
  onConfirm,
  message,
  confirmLabel = "Confirm",
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      maxWidth="420px"
      padding={24}
      showCloseButton={false}
    >
      <Content column gap="16px">
        {typeof message === "string" ? <p>{message}</p> : message}
        <ButtonContainer justifyContent="flex-end" gap="8px">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            buttonType="primary"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            {confirmLabel}
          </Button>
        </ButtonContainer>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  "& p": {
    margin: 0,
  },
});

const ButtonContainer = styled(Flex)({});
